import Team from '@/plugins/sdk/resources/Team'
import Request, { POST } from '@/plugins/sdk/Request'

export default class extends Team {
  static name = 'account_team'

  static async impersonate (account, tenancy, callback) {
    const request = await (Object.assign(new Request(), {
      method: POST,
      _pathname: 'open360/impersonate',
      body: {
        account: account,
        tenancy: tenancy
      }
    })).build()

    const response = await fetch(request)

    if (response.ok) {
      const data = await response.json()
      if (data.data.redirect) {
        // this.$message.success('Impersonation Token Generated. Redirecting to Open360...')
        // open redirect in _blank
        window.open(data.data.redirect, '_blank')
        return true
      }
    } else {
      this.$message.error('Failed to generate impersonation token for Open360.')
      return false
    }
  }
}
